import TextFieldAdapter, { TextFieldAdapterProps } from './TextFieldAdapter';
import { phone } from '../helper/validators';

export const PhoneFieldAdapter = (props: Omit<TextFieldAdapterProps, 'mask'>) => {
  return <TextFieldAdapter {...props} mask="00{ }00{ }00{ }00{ }00" validators={[phone]} />;
};
